import { setupPasswordTogglers } from "../shared/password-toggler";
import * as b2c from "./self-asserted.dom";


/**
 * Initialize Unified template logic
 */
export function initUnified() {
    unifiedEmail();
    unifiedPassword();
}


/**
 * Password logic
 */
export function unifiedEmail() {
    /* Remove placeholder */
    b2c.emailField ? b2c.emailField.setAttribute('placeholder', '') : '';
}

/**
 * Password logic
 */
export function unifiedPassword() {
    /* Remove placeholders */
    b2c.passwordChooseField ? b2c.passwordChooseField.setAttribute('placeholder', '') : '';
    b2c.passwordConfirmField ? b2c.passwordConfirmField.setAttribute('placeholder', '') : '';
    b2c.passwordForgotLink ? b2c.passwordForgotLink.setAttribute('tabindex', '-1') : '';

    /* TODO: setup togglers for reset-password page (listen for insertion of password fields in mutation observer) */
    /* TODO: add password toggle triggers without wrapping the password field (this destroys B2C validation messages toggle logic for this field somehow) */
    // setupPasswordTogglers();
}
